<section>
  <div class="quantity-card">
    <div class="grid-12">
      <div class="span-6">
        <h2>500</h2>
        <h4>Min. Machine Capacity</h4>
      </div>
      <div class="divider"></div>
      <div class="span-6">
        <h2>2000</h2>
        <h4>Max. Machine Capacity</h4>
      </div>
    </div>
  </div>
</section>

<section>
  <div class="grid-12">
    <div class="span-6">
      <div class="form-box">
        <div class="form-box">
          <label for="">Quantity to use</label>
          <p-inputNumber class="w-full" />
        </div>
      </div>
    </div>
  </div>
</section>

<section>
  <h5 class="line subtitle subtitle__margin-0">Machine Information</h5>
  <div class="grid-2">
    <div>
      <label for="on_label">Asset</label>
      <input pInputText type="text" class="w-full" value="DM" disabled />
    </div>
    <div>
      <label for="on_label">Number of Ports</label>
      <input pInputText type="number" class="w-full" value="9" disabled />
    </div>
    <div>
      <label for="on_label">Kgs per Ports</label>
      <input pInputText type="number" class="w-full" value="500" disabled />
    </div>
    <div>
      <label for="on_label">Submitted Date</label>
      <p-datepicker [iconDisplay]="'input'" [showIcon]="true" disabled />
    </div>
    <div>
      <label for="on_label">Approved Date</label>
      <p-datepicker [iconDisplay]="'input'" [showIcon]="true" value="2021-07-01" disabled />
    </div>
  </div>
</section>

<section>
  <h5 class="line subtitle subtitle__margin-0">Color</h5>
  <app-color-info />
</section>
